import React from 'react';
import { Button } from 'react-bootstrap';
import { ICON_REMOVE } from '../../extras/icons';

const InterveeningInfoForm = props => {
    //Tomo los props
    const { intervening, handleRemove } = props;
    //Renderizo
    return (
        <tr>
            <td className="align-middle">
                { intervening.persona.apellido + ', ' + intervening.persona.nombre}
            </td>
            <td className="align-middle">
                { intervening.caracter ? intervening.caracter.descripcion : 'N/D' }
            </td>
            <td className="align-middle text-center">
                { intervening.telefono }
            </td>
            <td className="align-middle text-center">
                { intervening.email }
            </td>
            <td className="align-middle text-center">
                { intervening.domicilio }
            </td>
            <td className="align-middle text-center">
                <Button variant="danger" size="sm" onClick={() => handleRemove(intervening)}>
                    <ICON_REMOVE />
                </Button>
            </td>
        </tr>
    );
};

export default InterveeningInfoForm;